import {useEffect} from "react";
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {Modal} from "@pg-design/modal-module";
import {getPhoneDataFromString} from "@pg-mono/string-utils";

import {ApplicationMultiLead} from "../../../application/components/multi_lead/ApplicationMultiLead";
import {leadModalZindex} from "../../../application/constants/lead/lead_modal_zindex";
import {useMultiLeadRecommendations} from "../../../application/hooks/multi_lead/use_application_multi_lead_recommendations";
import {IApplicationFormValues} from "../../../application/types/form/IApplicationFormValues";
import {ApplicationMultiLeadRecommendationType} from "../../../application/types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadTracking} from "../../../application/types/multi_lead/ApplicationMultiLeadTracking";
import {IApplicationMultiLeadSummaryStepState} from "../../../application/types/multi_lead/IApplicationMultiLeadSummaryStepState";
import {ApplicationSourceSection} from "../../../application/utils/form/application_form_source";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {useGetHomeMatchConfigurationQuery} from "../../../user/api/patch_home_match_configuration";
import {HomeMatchBasicPreferencesFlowSource} from "../../../user/types/HomeMatchBasicPreferencesFlowTypes";
import {gtmRegistrationMultileadClick, gtmRegistrationMultileadClose, gtmRegistrationMultileadView} from "../../tracking/registration_multilead_tracking";

interface IProps {
    onComplete: (isHomeMatchOn: boolean, source: HomeMatchBasicPreferencesFlowSource) => void;
    onClose: (isHomeMatchOn: boolean) => void;
}

export const RegistrationMultilead = ({onComplete, onClose}: IProps) => {
    const {data: userProfile, isLoading: isProfileLoading} = useGetUserProfileQuery();
    const {data: homeMatchConfig} = useGetHomeMatchConfigurationQuery();
    const flowState = useAppSelector((state) => state.registrationFlow);
    const {areRecommendationsLoading, areRecommendationsEmpty, recommendedProperties} = useMultiLeadRecommendations({
        propertyId: flowState.propertyId,
        offerId: flowState.offerId
    });
    const totalOffers = recommendedProperties.length + 1;

    useEffect(() => {
        if (!areRecommendationsLoading && areRecommendationsEmpty) {
            handleClose();
        }
    }, [areRecommendationsLoading, areRecommendationsEmpty]);

    const originalApplicationFormValues: IApplicationFormValues | null = userProfile
        ? {
              name: userProfile.name ?? "",
              email: userProfile.email ?? "",
              phone: getPhoneDataFromString(userProfile.phone ?? ""),
              marketing_email: userProfile.email_marketing_consent ?? false,
              marketing_sms: userProfile.phone_marketing_consent ?? false
          }
        : null;

    const handleComplete = (_payload?: IApplicationMultiLeadSummaryStepState) => {
        onComplete(homeMatchConfig?.is_active ?? false, "afterMultilead");
    };

    const handleClose = () => {
        onClose(homeMatchConfig?.is_active ?? false);
    };

    const registrationTracking: ApplicationMultiLeadTracking = {
        onView: gtmRegistrationMultileadView,
        onClose: gtmRegistrationMultileadClose,
        onSend: gtmRegistrationMultileadClick
    };

    const content = (() => {
        if (isProfileLoading || areRecommendationsLoading) {
            return (
                <div className={loaderWrapperStyle}>
                    <Loader size="lg" fullWidth />
                </div>
            );
        }

        if (!originalApplicationFormValues || !flowState.propertyId || !flowState.offerId || !flowState.vendorId) {
            return null;
        }

        return (
            <ApplicationMultiLead
                originalApplicationResponse={null}
                sourceSection={ApplicationSourceSection.POPUP_MODAL}
                recommendationType={ApplicationMultiLeadRecommendationType.PROPERTY}
                originalApplicationFormValues={originalApplicationFormValues}
                recommendationsWithPriceFilter
                showOriginalOffer
                handleModalClose={handleClose}
                handleSetMultiLeadSummaryStep={handleComplete}
                customGtmTracking={registrationTracking}
                customSourceSection="post_price_reveal_multilead"
                disableDefaultSelection
            />
        );
    })();

    return (
        <Modal
            isOpen
            onModalClose={() => {
                gtmRegistrationMultileadClose(totalOffers);
                handleClose();
            }}
            zIndex={leadModalZindex}
            showCloseButton={false}
            fullScreen="xs"
        >
            <div className={contentWrapperStyle}>{content}</div>
        </Modal>
    );
};

const contentWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    overflow: "hidden",
    height: "100%",
    width: "100%",
    minWidth: "28rem"
});

const loaderWrapperStyle = css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "24rem",

    md: {
        width: "560px",
        height: "auto",
        minHeight: "28rem"
    }
});
import {useEffect} from "react";
import {css} from "@panda/css";

import {Loader} from "@pg-design/loader-module";
import {Modal} from "@pg-design/modal-module";
import {getPhoneDataFromString} from "@pg-mono/string-utils";

import {ApplicationMultiLead} from "../../../application/components/multi_lead/ApplicationMultiLead";
import {leadModalZindex} from "../../../application/constants/lead/lead_modal_zindex";
import {useMultiLeadRecommendations} from "../../../application/hooks/multi_lead/use_application_multi_lead_recommendations";
import {IApplicationFormValues} from "../../../application/types/form/IApplicationFormValues";
import {ApplicationMultiLeadRecommendationType} from "../../../application/types/multi_lead/ApplicationMultiLeadRecommendationType";
import {ApplicationMultiLeadTracking} from "../../../application/types/multi_lead/ApplicationMultiLeadTracking";
import {IApplicationMultiLeadSummaryStepState} from "../../../application/types/multi_lead/IApplicationMultiLeadSummaryStepState";
import {ApplicationSourceSection} from "../../../application/utils/form/application_form_source";
import {useAppSelector} from "../../../store/hooks";
import {useGetUserProfileQuery} from "../../../user/api/get_user_profile";
import {useGetHomeMatchConfigurationQuery} from "../../../user/api/patch_home_match_configuration";
import {HomeMatchBasicPreferencesFlowSource} from "../../../user/types/HomeMatchBasicPreferencesFlowTypes";
import {gtmRegistrationMultileadClick, gtmRegistrationMultileadClose, gtmRegistrationMultileadView} from "../../tracking/registration_multilead_tracking";

interface IProps {
    onComplete: (isHomeMatchOn: boolean, source: HomeMatchBasicPreferencesFlowSource) => void;
    onClose: (isHomeMatchOn: boolean) => void;
}

export const RegistrationMultilead = ({onComplete, onClose}: IProps) => {
    const {data: userProfile, isLoading: isProfileLoading} = useGetUserProfileQuery();
    const {data: homeMatchConfig} = useGetHomeMatchConfigurationQuery();
    const flowState = useAppSelector((state) => state.registrationFlow);
    const {areRecommendationsLoading, areRecommendationsEmpty, recommendedProperties} = useMultiLeadRecommendations({
        propertyId: flowState.propertyId,
        offerId: flowState.offerId
    });
    const totalOffers = recommendedProperties.length + 1;

    useEffect(() => {
        if (!areRecommendationsLoading && areRecommendationsEmpty) {
            handleClose();
        }
    }, [areRecommendationsLoading, areRecommendationsEmpty]);

    const originalApplicationFormValues: IApplicationFormValues | null = userProfile
        ? {
              name: userProfile.name ?? "",
              email: userProfile.email ?? "",
              phone: getPhoneDataFromString(userProfile.phone ?? ""),
              marketing_email: userProfile.email_marketing_consent ?? false,
              marketing_sms: userProfile.phone_marketing_consent ?? false
          }
        : null;

    const handleComplete = (_payload?: IApplicationMultiLeadSummaryStepState) => {
        onComplete(homeMatchConfig?.is_active ?? false, "afterMultilead");
    };

    const handleClose = () => {
        onClose(homeMatchConfig?.is_active ?? false);
    };

    const registrationTracking: ApplicationMultiLeadTracking = {
        onView: gtmRegistrationMultileadView,
        onClose: gtmRegistrationMultileadClose,
        onSend: gtmRegistrationMultileadClick
    };

    const content = (() => {
        if (isProfileLoading || areRecommendationsLoading) {
            return (
                <div className={loaderWrapperStyle}>
                    <Loader size="lg" fullWidth />
                </div>
            );
        }

        if (!originalApplicationFormValues || !flowState.propertyId || !flowState.offerId || !flowState.vendorId) {
            return null;
        }

        return (
            <ApplicationMultiLead
                originalApplicationResponse={null}
                sourceSection={ApplicationSourceSection.POPUP_MODAL}
                recommendationType={ApplicationMultiLeadRecommendationType.PROPERTY}
                originalApplicationFormValues={originalApplicationFormValues}
                recommendationsWithPriceFilter
                showOriginalOffer
                handleModalClose={handleClose}
                handleSetMultiLeadSummaryStep={handleComplete}
                customGtmTracking={registrationTracking}
                customSourceSection="post_price_reveal_multilead"
                disableDefaultSelection
            />
        );
    })();

    return (
        <Modal
            isOpen
            onModalClose={() => {
                gtmRegistrationMultileadClose(totalOffers);
                handleClose();
            }}
            zIndex={leadModalZindex}
            showCloseButton={false}
            fullScreen="xs"
        >
            <div className={contentWrapperStyle}>{content}</div>
        </Modal>
    );
};

const contentWrapperStyle = css({
    display: "flex",
    flexDirection: "row",
    alignItems: "stretch",
    overflow: "hidden",
    height: "100%",
    width: "100%",
    minWidth: "28rem"
});

const loaderWrapperStyle = css({
    position: "relative",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minHeight: "24rem",

    md: {
        width: "560px",
        height: "auto",
        minHeight: "28rem"
    }
});
